/**
 * Governance — Dicionário PT-BR
 *
 * Estrutura por domínio/chave compatível com migração futura para react-i18next.
 * Chaves em camelCase; acesso: t.governance.controlTower.title
 * Futuro i18next: t('governance.controlTower.title') — sem refatoração estrutural.
 */
const pt = {
  governance: {
    controlTower: {
      loading:        'Carregando dados do Control Tower...',
      errorTitle:     'Erro ao carregar dados',
      subtitle:       'Visão operacional em tempo real - Métricas NOW + Ações rápidas + Incidentes ativos',
      sectionNow:     'NOW — Métricas de Hoje',
      sectionWorker:  '⚙️ Worker & Pipeline',
      sectionActions: 'Quick Actions',
      sectionIncidents: '🚨 Top Incidents (Últimos 10)',
      viewAll:         'Ver todos',
      noIncidents:     'Nenhum incidente ativo',
      noIncidentsDesc: 'Sistema operando normalmente',
      footer:          'Dados atualizados em tempo real (environment: production)',
      plannerTitle:    'Strategic Planner',
      plannerDesc:     'Criar plano estratégico com custo projetado',
      builderTitle:    'Builder',
      builderDesc:     'Gerar tasks Copilot-ready a partir do plano',
      agentsTitle:     'AI Agents',
      agentsSubtitle:  '14 agentes ativos',
      agentsDesc:      'Enable/disable agentes e monitorar health',
      errorsLabel:     'erros',
      dateLocale:      'pt-BR',
    },

    onboarding: {
      title:         'Bem-vindo ao VUKZ',
      subtitle:      'Configure sua conta e ative sua plataforma de inteligência',
      step1Label:    'Organização',
      step2Label:    'Plano',
      step3Label:    'Usuários',
      step4Label:    'Pronto',
      step1Title:    'Dados da organização',
      step1Desc:     'Confirme os dados da sua empresa para configurar a conta corretamente.',
      step2Title:    'Seu plano ativo',
      step2Desc:     'Verifique o plano contratado e os limites incluídos.',
      step3Title:    'Convidar usuários',
      step3Desc:     'Adicione os membros da sua equipe e atribua papéis de acesso.',
      step4Title:    'Tudo pronto!',
      step4Desc:     'Sua conta VUKZ está configurada. Acesse o painel de governança.',
      orgNameLabel:    'Nome da organização',
      orgSectorLabel:  'Setor',
      orgCountryLabel: 'País',
      planLabel:       'Plano atual',
      planActiveUntil: 'Ativo até',
      addUserBtn:      'Adicionar usuário',
      emailPlaceholder:'E-mail do usuário',
      rolePlaceholder: 'Selecionar papel',
      nextBtn:         'Próximo',
      backBtn:         'Voltar',
      finishBtn:       'Ir para o painel',
      inviteBtn:       'Enviar convites',
      skipBtn:         'Pular por agora',
      stepOf:          (current, total) => `Etapa ${current} de ${total}`,
      alreadyConfigured: 'Conta já configurada.',
      goToDashboard:   'Acessar governança',
      roleOptions: {
        gov_manager:   'Gestor Governança',
        sports_manager:'Gestor Sports',
        analyst:       'Analista',
        viewer:        'Visualizador',
        finance:       'Financeiro',
        hr:            'RH',
      },
      sectorOptions: {
        sports:      'Esportes',
        corporate:   'Corporativo',
        education:   'Educação',
        health:      'Saúde',
        government:  'Governo',
        other:       'Outro',
      },
      inviteSent:    'Convites enviados.',
      inviteError:   'Erro ao enviar convites.',
      saveOrgError:  'Erro ao salvar organização.',
    },

    users: {
      // Documentação das chaves para migração futura (GovernanceUsersPage já traduzido inline)
      // Manter sincronizado com getT() em GovernanceUsersPage.jsx
      pageTitle:    'Usuários & Acessos',
      pageSubtitle: 'Gerencie usuários, papéis, permissões e planos da plataforma VUKZ.',
    },
  },
};

export default pt;
